import React from 'react'

import ConfirmationDialog from 'components/Modal/ConfirmationDialog/ConfirmationDialog'

const RemoveAudioModal = ({ data = {}, onSubmit = () => {}, onClose = () => {} }) => (
    <ConfirmationDialog
        onClose={() => onClose()}
        onAction={async () => onSubmit(data)}
        successText="Audio removed successfully!"
        headText="Please, confirm"
        noteText={`Are you sure you want to remove this audio?`}
        targetText={data.name}
        actionVariant="danger"
        actionText="Remove"
        cancelText="Cancel"
    />
)

export default RemoveAudioModal
